/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
v3RegistrationApp.controller("accountMergeCtrl",['$scope', '$routeParams', 'DebugHelper', 'V3SessionResource', '$window', 'V3MergeRequestsResource', function($scope, $routeParams, DebugHelper, V3SessionResource, $window, V3MergeRequestsResource){
  DebugHelper.register("accountMergeCtrl", $scope);

  _.assignIn($scope, {
    stateUI: {
      error: false,
      success: false
    },

    initialize() {
      return V3MergeRequestsResource.update(
        {id: $routeParams.id}
      , success => $scope.stateUI.success = true
      , error => $scope.stateUI.error = true);
    }
  }
  );


  return $scope.initialize();
}
]);
